/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EntityUserInput } from '../../models/entity-user-input';
import { Response } from '../../models/response';

export interface ApiKeycloakUpdateUserPost$Plain$Params {
  Authorization?: string;
      body?: EntityUserInput
}

export function apiKeycloakUpdateUserPost$Plain(http: HttpClient, rootUrl: string, params?: ApiKeycloakUpdateUserPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Response>> {
  const rb = new RequestBuilder(rootUrl, apiKeycloakUpdateUserPost$Plain.PATH, 'post');
  if (params) {
    rb.header('Authorization', params.Authorization, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Response>;
    })
  );
}

apiKeycloakUpdateUserPost$Plain.PATH = '/api/keycloak/UpdateUser';
